module.exports = __webpack_public_path__ + "img/1MenuActivate.ab617652.png";